import type { AdminDashboardSummary, DashboardStats } from "../WarehouseApi";
import type { WarehouseApiModuleContext } from "./WarehouseApiModuleContext";

type NormalizeDashboardStats = (
  payload: unknown,
  fallbackErrorMessage: string,
) => DashboardStats;

type NormalizeAdminDashboardSummary = (
  payload: unknown,
  fallbackErrorMessage: string,
) => AdminDashboardSummary;

export class DashboardApiModule {
  constructor(
    private readonly context: Pick<WarehouseApiModuleContext, "getJson">,
    private readonly normalizeDashboardStats: NormalizeDashboardStats,
    private readonly normalizeAdminDashboardSummary: NormalizeAdminDashboardSummary,
  ) {}

  async getDashboardStats(expiringDays = 7): Promise<DashboardStats> {
    const query = new URLSearchParams();

    if (Number.isFinite(expiringDays)) {
      query.set("expiringDays", String(Math.max(1, Math.floor(expiringDays))));
    }

    const path = query.toString()
      ? `/api/dashboard/stats?${query.toString()}`
      : "/api/dashboard/stats";
    const payload = await this.context.getJson<unknown>(path);

    return this.normalizeDashboardStats(
      payload,
      "Некорректный ответ сервера при загрузке статистики",
    );
  }

  async getAdminDashboardSummary(): Promise<AdminDashboardSummary> {
    const payload = await this.context.getJson<unknown>(
      "/api/dashboard/admin-summary",
    );

    return this.normalizeAdminDashboardSummary(
      payload,
      "Некорректный ответ сервера при загрузке admin-статистики",
    );
  }
}
